const items = document.querySelectorAll('[data-step]');
const fill = document.querySelector('.timeline-fill');
const section = document.querySelector('.timeline');

function animateTimeline() {
    const top = section.offsetTop;
    const height = section.offsetHeight;

    const scroll = window.scrollY + window.innerHeight * 0.5;
    const progress = Math.max(0, scroll - top);

    const percent = Math.min(100, (progress / height) * 100);
    fill.style.height = percent + '%';

    items.forEach(item => {
        const dot = item.querySelector('.timeline-dot');

        const dotTop = dot.getBoundingClientRect().top + window.scrollY;
        const sectionTop = section.offsetTop;

        const dotOffset = dotTop - sectionTop;

        if (progress >= dotOffset) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
}

window.addEventListener('scroll', animateTimeline);
window.addEventListener('load', animateTimeline);